<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="产品装配工艺"
      edit-title
      id-key="UserId"
      :data="data"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="beforeSave"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      @close-saved="$emit('close-saved')"
      @create-opened="createOpened"
      @edit-opened="editOpened"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="方案名称" prop="ProgrammeName">
                <el-input
                  clearable
                  v-model="data.ProgrammeName"
                  placeholder="请输入方案名称"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="序号" prop="Sn">
                <el-input
                  clearable
                  v-model="data.Sn"
                  placeholder="请输入序号"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="排产类型" prop="SchedulingType">
                <el-select
                  v-model="data.SchedulingType"
                  placeholder="请选择排产类型"
                  clearable
                >
                  <el-option :value="0"  label="部门"></el-option>
                  <el-option :value="1"  label="设备"></el-option>
                  
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="是否为默认工艺" prop="IsDefault" label-width="120px">
                <el-select
                  v-model="data.IsDefault"
                  placeholder="请选择是否为默认工艺"
                  clearable
                >
                  <el-option :value="false"  label="否"></el-option>
                  <el-option :value="true"  label="是"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <wj-sub-table
          title="产品列表"
          :data="Products"
          ref="Moulds_wjsubTable"
          :column="['ProductNo', 'ProductName']"
        >
          <template slot="table">
            <el-table-column
              prop="ProductNo"
              label="产品编码" 
              min-width="110"
              align="center"
            >
              <template slot-scope="{ row }">
                <el-select
                  clearable
                  filterable
                  v-model="row.ProductNo"
                  @change="productChange(row)"
                  placeholder="请选择产品编码"
                >
                  <el-option
                    v-for="item in productList"
                    :key="item.ProductNo"
                    :label="getLabel(item)"
                    :value="item.ProductNo"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="ProductName"
              label="产品名称"
              min-width="110"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{ row.ProductName }}</span>
              </template>
            </el-table-column>
          </template>
        </wj-sub-table>

        <wj-sub-table
          ref="Process_wjsubTable"
          title="工序信息"
          :data="Processes"
          :column="['ProcessName', 'ProcessNo']"
        >
          <template slot="table">
            <el-table-column
              prop="ProcessName"
              label="工序名称"
              min-width="110"
              align="center"
            >
              <template slot-scope="{ row }">
                <el-select
                  clearable
                  v-model="row.ProcessName"
                  @change="changeProcess(row)"
                  placeholder="请选择工序名称"
                >
                  <el-option
                    v-for="item in processList"
                    :key="item.ProcessId"
                    :label="item.ProcessName"
                    :value="item.ProcessName"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="ProcessNo"
              label="工序序号"
              min-width="110"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{ row.ProcessNo }}</span>
              </template>
            </el-table-column>
          </template>
        </wj-sub-table>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import wjSubTable from "../common/wjSubTable";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    wjSubTable,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      processApi: require('@/api/production/teProcess').default,
      productApi: require('@/api/ba/product').default,
      api: require('@/api/production/teProgramme').default,
      data: {
        ProgrammeId: 0,
        ProgrammeName: "",
        ProgrammeType: 2,
        ProductType: 1,
        Sn: 0,
        SchedulingType: "",
        Products: [],
        Processes: [],
        IsDefault: null,
      },
      processList: [],
      productList: [],
      Products: [],
      Processes: [],
      rules: {
        ProgrammeName: [{ required: true, message: "请输入方案名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
        SchedulingType: [{ required: true, message: "请选择排产类型" }],
        IsDefault: [{ required: true, message: "请选择是否为默认工艺" }],
      },
    };
  },
  methods: {
    getLabel(item){
      return item.ProductNo + `(${item.ProductName})`
    },
    getList(){
      this.processApi.list({}).then((res) => {
          if (res.Code === 0) {
            this.processList = res.Data
          }
        });

        this.productApi.list({Status: 1, ProcessStage: 3}).then(res => {
          if(res.Code === 0){
            this.productList = res.Data;

            console.log('this.productList', this.productList)
          }
        })
    },
    init(){
      if (this.type === 0) {
          this.data = {
            ProgrammeId: 0,
            ProgrammeName: "",
            ProgrammeType: 2,
            ProductType: 1,
            Sn: 0,
            SchedulingType: "",
            Products: [],
            Processes: [],
            IsDefault: null,
          };

          this.Products = []
          this.Processes = []
        }

        this.getList();

        this.api.getMaxSn(this.data.ProgrammeType).then(res => {
          this.$set(this.data, 'Sn', res)
        })
    },
    changeProcess(row) {
      let o = this.processList.map((v) => {
        return v.ProcessName;
      });

      let index = o.indexOf(row.ProcessName);
      row.ProcessNo = this.processList[index].ProcessNo;

      if(row.T == null){
        row.T = 1;
      }
    },
    productChange(row) {
      let o = this.productList.map((v) => {
        return v.ProductNo;
      });
      let index = o.indexOf(row.ProductNo);
      row.ProductName = this.productList[index].ProductName;

      if(row.T == null){
        row.T = 1;
      }
    },
    editOpened(data){
      this.getList();
      data.IsDefault = data.IsDefault
      data.Products.forEach(item => {
        item.T = null;
      })
      this.Products  = data.Products
      data.Processes.forEach(item => {
        item.T = null;
      })
      this.Processes  = data.Processes
      
    },
    createOpened(data){
       this.init();   
    },
    beforeSave() {
      let bool = true;

      let saveDataProduct = this.$refs.Moulds_wjsubTable.getTable();
      let saveDataProcess = this.$refs.Process_wjsubTable.getTable();

      this.$refs.Moulds_wjsubTable.clearDel();
      this.$refs.Process_wjsubTable.clearDel();


      let productNos = this.productList.map(item => {
        return item.ProductNo
      })
      let processNos = this.processList.map(item => {
        return item.ProcessNo
      })

      saveDataProduct.forEach(item => {

        let index = productNos.indexOf(item.ProductNo);
        if(index !== -1){
          item.ProductId = this.productList[index].ProductId;
          item.ProductName = this.productList[index].ProductName;
          item.ProductNo = this.productList[index].ProductNo;
          item.ProgrammeName = this.data.ProgrammeName;
          item.ProgrammeType = this.data.ProgrammeType;
          item.SchedulingType = this.data.SchedulingType;
        }
        

      })

      saveDataProcess.forEach(item => {

        let index = processNos.indexOf(item.ProcessNo);
        if(index !== -1){
          item.ProcessId = this.processList[index].ProcessId;
          item.Sn = this.processList[index].Sn;
          item.Stage = this.processList[index].Stage;
          item.ProgrammeName = this.data.ProgrammeName;
          item.ProgrammeType = this.data.ProgrammeType;
          item.SchedulingType = this.data.SchedulingType;
        }
        

      })

      saveDataProduct.forEach(item => {
        if(item.T == null){
          item.T = 1
        }
      })

      saveDataProcess = saveDataProcess.filter(item => {
        return item.T !== null;
      })

      this.data.Products = saveDataProduct;
      this.data.Processes = saveDataProcess;

      if (this.data.Products.length === 0) {
        this.$message({ type: "warning", message: "产品列表至少要有一条记录" });
        bool = false;
      }

      this.data.Products.forEach((v) => {
        if (v.ProductNo === "") {
          this.$message({ type: "warning", message: "请完整填写产品列表" });
          bool = false;
        }
      });

      // if(this.data.Processes.length === 0){
      //    this.$message({type: 'warning', message: '工序信息至少要有一条记录'})
      //   bool = false;
      // }

      this.data.Processes.forEach(v => {

        if(v.ProcessNo === ''){
          this.$message({type: 'warning', message: '请完整填写工序信息'})
          bool = false
        }
      })

      if (!bool) {
        return bool;
      }

    },
  },
};
</script>
